import { performChallenge } from './worldpay-challenge';
import { logTaggedMessage } from '../../reporter';
const log = logTaggedMessage({
    module: '3ds',
    sub_module: 'worldpay_v1fallback',
});
export const performV1Fallback = async (action) => {
    const { data, methodUrl, notificationUrl, provider } = action;
    const result = await performChallenge({
        data: data,
        methodUrl,
        notificationUrl,
        provider,
    }, log);
    const { challengeData } = result;
    const res = {
        v1FallbackData: {
            ...challengeData,
        },
    };
    return res;
};
//# sourceMappingURL=worldpay-v1fallback.js.map